module.exports = __webpack_public_path__ + "8439ab08d65d5b2011426381c7fd798b.png";